import { render } from "./App.vue?vue&type=template&id=671c78cd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=671c78cd&lang=css"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__